import { Form, Input } from 'sections/Form';

import { useNewPassword } from './NewPasswordForm.hooks';

export type Attributes = {
  name: string;
  family_name: string;
  password: string;
};

export function NewPasswordForm(): React.ReactElement {
  const { handleSubmit, register, onSubmit } = useNewPassword();

  const inputs: Input[] = [
    {
      name: 'name',
      label: 'name:',
    },
    {
      name: 'family_name',
      label: 'family name:',
    },
    {
      name: 'password',
      label: 'new password:',
      type: 'password',
    },
  ];

  return (
    <Form
      buttonLabel="submit"
      register={register}
      onSubmit={handleSubmit(onSubmit)}
      inputs={inputs}
    />
  );
}
